var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductsV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7545 5.72337L10.2167 10.0754L2.67578 5.71643",
    stroke: "white",
    strokeWidth: 1.50984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2188 10.0753V18.1637",
    stroke: "white",
    strokeWidth: 1.50984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31796 1.60715C9.87409 1.28606 10.5593 1.28606 11.1154 1.60715L17.1011 5.06297C17.6572 5.38405 17.9998 5.97743 17.9998 6.61958V13.5312C17.9998 14.1734 17.6572 14.7668 17.1011 15.0879L11.1154 18.5436C10.5593 18.8647 9.87409 18.8647 9.31796 18.5436L3.33231 15.0879C2.77617 14.7668 2.43359 14.1734 2.43359 13.5312V6.61958C2.43359 5.97743 2.77617 5.38405 3.33231 5.06297L9.31796 1.60715Z",
    stroke: "white",
    strokeWidth: 1.50984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07031 3.33508L13.8107 7.37929L14 11.9999",
    stroke: "white",
    strokeWidth: 1.50984,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsV2);
export default __webpack_public_path__ + "static/media/productsV2.c8f198273ece603f930459f57ca11d41.svg";
export { ForwardRef as ReactComponent };